import { CaseState } from '@/static/enums/caseState';
import { caseStatesEditable } from '@/static/enums/caseStateEditable';
import { CaseStateToLabel } from '@/static/enums/caseStateToLabel';
import { CaseStatus } from '@/static/enums/caseStatus';
import { caseStatusesEditable } from '@/static/enums/caseStatusEditable';
import { CaseStatusToLabel } from '@/static/enums/caseStatusToLabel';

/**
 * Returns translation label to be used for tooltip to show that case
 * cannot be currently edited due state or status it is currently in.
 */
export function getCaseIsUneditableTooltipLabel(caseObject: any): string {
    if (caseObject && 'state' in caseObject && !caseStatesEditable[caseObject.state as CaseState]) {
        return CaseStateToLabel[caseObject.state as CaseState];
    }

    if (caseObject && 'status' in caseObject && !caseStatusesEditable[caseObject.status as CaseStatus]) {
        return CaseStatusToLabel[caseObject.status as CaseStatus];
    }

    if (caseObject && 'transfer_id' in caseObject && caseObject.transfer_id !== null) {
        return 'case.status.in_transfer';
    }

    return "";
}
